import { useTranslation } from 'next-i18next'
import React from 'react'
import { Modal, Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import UiKitButton from '@ui-kit/components/Button/index'
import { body2, h4 } from '@ui-kit/core/typography'

const modalStyles = tv({
  slots: {
    backdrop: 'flex flex-1 flex-col items-center justify-center bg-backdrop',
    modalContainer:
      ' mx-auto mt-20 flex justify-center rounded-xl bg-white px-4 py-5 md:w-full md:max-w-[560px]',
    buttonsContainer:
      'grid w-full grid-cols-1 gap-y-2 bg-white py-2 pb-2 pt-2 md:grid-cols-2 md:gap-x-2 md:gap-y-0',
    modalTitle: [h4(), 'pb-3'],
  },
})

export const StartOverModal = (props: {
  onReset: () => void
  visible: boolean
  onContinue: () => void
}) => {
  const { backdrop, modalContainer, buttonsContainer, modalTitle } = modalStyles()

  const { t } = useTranslation()

  if (typeof document !== 'undefined') {
    document.body.classList.remove('overflow-y-hidden')
    if (props.visible) {
      document.body.classList.add('overflow-y-hidden')
    }
  }

  return (
    <Modal transparent animationType="fade" visible={props.visible}>
      <View className={backdrop()}>
        <View className={modalContainer()}>
          <Text className={modalTitle()}>{t(`common:startOverModal.title`)}</Text>
          <Text className={body2()}> {t(`common:startOverModal.subtitle`)}</Text>
          <View className={buttonsContainer()}>
            <UiKitButton
              onPress={props.onReset}
              variantColor={'grey500'}
              label={t(`common:startOverModal.startOver.buttonLabel`)}
              id={'start_over_button'}
            ></UiKitButton>
            <UiKitButton
              onPress={props.onContinue}
              variantColor={'black'}
              label={t(`common:startOverModal.continue.buttonLabel`)}
              id={'continue_button'}
            ></UiKitButton>
          </View>
        </View>
      </View>
    </Modal>
  )
}
